<template>
  <v-card class="outlined-card pa-5" elevation="0" :loading="loading">
    <div class="d-flex justify-space-between align-center mb-4">
      <h3 class="text-subtitle-1 font-weight-bold text-uppercase" style="color: #424242;">Chuyên cần</h3>
    </div>
    <v-row v-if="!loading">
      <v-col cols="12" md="3">
        <div class="text-subtitle-1 font-weight-bold mb-1">Số lượng học sinh hôm nay</div>
        <div class="text-h4 font-weight-bold mb-1">
          {{ formatNumber(today.totalPresent) }} <span class="text-body-2 grey--text font-weight-normal">({{ getPercent(today.totalPresent, today.totalPresent + today.totalAbsent) }}%)</span>
        </div>
        <div class="text-body-2 font-weight-bold d-flex align-center mb-1">
          <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #4CAF50; margin-right: 8px;"></div>
          Có mặt
        </div>
        <div class="text-body-2 grey--text mb-4 pl-4 d-flex flex-column">
          <span class="mb-1 d-flex justify-space-between"><span>• Đúng giờ</span> <span class="font-weight-bold black--text">{{ formatNumber(today.onTime) }}</span></span>
          <span class="d-flex justify-space-between"><span>• Muộn giờ</span> <span class="font-weight-bold black--text">{{ formatNumber(today.lateTime) }}</span></span>
        </div>

        <div class="text-h4 font-weight-bold mb-1 mt-6">
          {{ formatNumber(today.totalAbsent) }} <span class="text-body-2 grey--text font-weight-normal">({{ getPercent(today.totalAbsent, today.totalPresent + today.totalAbsent) }}%)</span>
        </div>
        <div class="text-body-2 font-weight-bold red--text mb-1">Học sinh vắng mặt</div>
        <div class="text-body-2 grey--text d-flex justify-space-between mb-1">
          <span>• Có phép</span> <span class="font-weight-bold black--text">{{ formatNumber(today.excused) }}</span>
        </div>
        <div class="text-body-2 grey--text d-flex justify-space-between">
          <span>• Không phép</span> <span class="font-weight-bold red--text">{{ formatNumber(today.unexcused) }}</span>
        </div>
      </v-col>
      <v-col cols="12" md="9">
        <div class="d-flex flex-wrap justify-space-between align-center mb-4 pl-4">
          <div class="font-weight-bold text-subtitle-1 mb-2" style="color: #1a237e;">Thống kê theo tuần</div>
          <div class="d-flex justify-end text-caption grey--text text--darken-1" style="flex-wrap: wrap;">
            <div class="d-flex align-center mx-2 mb-2">
              <div style="width: 24px; height: 1px; background: #4CAF50; position: relative;" class="mr-2 d-flex align-center justify-center">
                <div style="width: 6px; height: 6px; border-radius: 50%; background: #4CAF50; z-index: 1;"></div>
                <div style="width: 12px; height: 12px; border-radius: 50%; background: rgba(76,175,80,0.3); position: absolute;"></div>
              </div>
              Đi đúng giờ
            </div>
            <div class="d-flex align-center mx-2 mb-2">
              <div style="width: 24px; height: 1px; background: #FFB300; position: relative;" class="mr-2 d-flex align-center justify-center">
                <div style="width: 6px; height: 6px; border-radius: 50%; background: #FFB300; z-index: 1;"></div>
                <div style="width: 12px; height: 12px; border-radius: 50%; background: rgba(255,179,0,0.3); position: absolute;"></div>
              </div>
              Đi muộn giờ
            </div>
            <div class="d-flex align-center mx-2 mb-2">
              <div style="width: 24px; height: 1px; background: #9E9E9E; position: relative;" class="mr-2 d-flex align-center justify-center">
                <div style="width: 6px; height: 6px; border-radius: 50%; background: #9E9E9E; z-index: 1;"></div>
                <div style="width: 12px; height: 12px; border-radius: 50%; background: rgba(158,158,158,0.3); position: absolute;"></div>
              </div>
              Vắng có phép
            </div>
            <div class="d-flex align-center ml-2 mb-2">
              <div style="width: 24px; height: 1px; background: #F44336; position: relative;" class="mr-2 d-flex align-center justify-center">
                <div style="width: 6px; height: 6px; border-radius: 50%; background: #F44336; z-index: 1;"></div>
                <div style="width: 12px; height: 12px; border-radius: 50%; background: rgba(244,67,54,0.3); position: absolute;"></div>
              </div>
              Vắng không phép
            </div>
          </div>
        </div>

        <div class="d-flex position-relative mt-6 mb-8" style="height: 250px;">
          <!-- Y-axis Labels -->
          <div class="d-flex flex-column justify-space-between text-caption grey--text text-right pr-3" style="min-width: 45px;">
            <span>{{ formatNumber(maxGraphValue) }}</span>
            <span>{{ formatNumber(maxGraphValue * 0.8) }}</span>
            <span>{{ formatNumber(maxGraphValue * 0.6) }}</span>
            <span>{{ formatNumber(maxGraphValue * 0.4) }}</span>
            <span>{{ formatNumber(maxGraphValue * 0.2) }}</span>
            <span>0</span>
          </div>

          <div style="flex-grow: 1; position: relative; margin-right: 40px; margin-left: 20px;">
            <!-- X-axis baseline -->
            <div style="position: absolute; bottom: 0; left: 0; right: 0; height: 1px; background: #9e9e9e;"></div>

            <!-- SVG Chart -->
            <svg width="100%" height="100%" style="overflow: visible; position: absolute; z-index: 1;" preserveAspectRatio="none">
              <!-- Grid lines -->
              <line x1="0%" y1="0%" x2="100%" y2="0%" stroke="#e0e0e0" stroke-width="1" stroke-dasharray="4 4" />
              <line x1="0%" y1="20%" x2="100%" y2="20%" stroke="#e0e0e0" stroke-width="1" stroke-dasharray="4 4" />
              <line x1="0%" y1="40%" x2="100%" y2="40%" stroke="#e0e0e0" stroke-width="1" stroke-dasharray="4 4" />
              <line x1="0%" y1="60%" x2="100%" y2="60%" stroke="#e0e0e0" stroke-width="1" stroke-dasharray="4 4" />
              <line x1="0%" y1="80%" x2="100%" y2="80%" stroke="#e0e0e0" stroke-width="1" stroke-dasharray="4 4" />

              <!-- Lines -->
              <g v-for="(day, index) in weekly.slice(0, -1)" :key="`line-${index}`">
                <line :x1="getPointX(index)" :y1="getPointY(day.onTime)" :x2="getPointX(index + 1)" :y2="getPointY(weekly[index + 1].onTime)" stroke="#4CAF50" stroke-width="1.5" />
                <line :x1="getPointX(index)" :y1="getPointY(day.lateTime)" :x2="getPointX(index + 1)" :y2="getPointY(weekly[index + 1].lateTime)" stroke="#FFB300" stroke-width="1.5" />
                <line :x1="getPointX(index)" :y1="getPointY(day.excused)" :x2="getPointX(index + 1)" :y2="getPointY(weekly[index + 1].excused)" stroke="#9E9E9E" stroke-width="1.5" />
                <line :x1="getPointX(index)" :y1="getPointY(day.unexcused)" :x2="getPointX(index + 1)" :y2="getPointY(weekly[index + 1].unexcused)" stroke="#F44336" stroke-width="1.5" />
              </g>

              <!-- Points (Circles) -->
              <g v-for="(day, index) in weekly" :key="`circles-${index}`">
                <!-- onTime -->
                <circle :cx="getPointX(index)" :cy="getPointY(day.onTime)" r="7" fill="rgba(76,175,80,0.3)" />
                <circle :cx="getPointX(index)" :cy="getPointY(day.onTime)" r="3.5" fill="#4CAF50" />
                <!-- lateTime -->
                <circle :cx="getPointX(index)" :cy="getPointY(day.lateTime)" r="7" fill="rgba(255,179,0,0.3)" />
                <circle :cx="getPointX(index)" :cy="getPointY(day.lateTime)" r="3.5" fill="#FFB300" />
                <!-- excused -->
                <circle :cx="getPointX(index)" :cy="getPointY(day.excused)" r="7" fill="rgba(158,158,158,0.3)" />
                <circle :cx="getPointX(index)" :cy="getPointY(day.excused)" r="3.5" fill="#9E9E9E" />
                <!-- unexcused -->
                <circle :cx="getPointX(index)" :cy="getPointY(day.unexcused)" r="7" fill="rgba(244,67,54,0.3)" />
                <circle :cx="getPointX(index)" :cy="getPointY(day.unexcused)" r="3.5" fill="#F44336" />
              </g>
            </svg>

            <!-- X-axis Labels -->
            <div class="text-caption grey--text font-weight-medium" style="position: absolute; bottom: -28px; left: 0; right: 0; height: 20px;">
              <div v-for="(day, index) in weekly" :key="`label-${index}`" style="position: absolute; transform: translateX(-50%);" :style="{ left: getPointX(index) }">
                {{ day.displayDate }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from 'moment'
import { SlotStudentAttendance } from '@/plugins/api'

export default {
  name: 'DashboardAttendanceChart',
  data() {
    return {
      maxGraphValue: 100,
      stats: null,
      loading: true
    }
  },
  computed: {
    today() {
      if (!this.stats || !this.stats.today) {
        return {
          totalPresent: 0,
          onTime: 0,
          lateTime: 0,
          totalAbsent: 0,
          excused: 0,
          unexcused: 0
        }
      }
      return this.stats.today
    },
    weekly() {
      if (!this.stats || !this.stats.weekly || !this.stats.weekly.length) {
        const w = []
        for (let i = 6; i >= 0; i--) {
          w.push({
            date: moment().subtract(i, 'days').format('YYYY-MM-DD'),
            displayDate: moment().subtract(i, 'days').format('DD/MM'),
            onTime: 0,
            lateTime: 0,
            excused: 0,
            unexcused: 0
          })
        }
        return w
      }
      return this.stats.weekly
    }
  },
  watch: {
    weekly: {
      immediate: true,
      handler() {
        this.calculateMaxValue()
      }
    }
  },
  created() {
    this.fetchStats()
  },
  methods: {
    async fetchStats() {
      this.loading = true
      try {
        const response = await SlotStudentAttendance.getDashboardStats()
        this.stats = response
      } catch (err) {
        console.error('Failed to fetch attendance chart stats:', err)
        this.stats = null
      } finally {
        this.loading = false
      }
    },
    formatNumber(num) {
      if (!num) return 0
      return num.toLocaleString('vi-VN')
    },
    getPercent(value, total) {
      if (!total || total === 0) return 0
      return ((value / total) * 100).toFixed(1)
    },
    calculateMaxValue() {
      let max = 10
      this.weekly.forEach(day => {
        if (day.onTime > max) max = day.onTime
        if (day.lateTime > max) max = day.lateTime
        if (day.excused > max) max = day.excused
        if (day.unexcused > max) max = day.unexcused
      })
      const magnitude = Math.pow(10, Math.floor(Math.log10(max)))
      this.maxGraphValue = Math.ceil(max / (magnitude / 2)) * (magnitude / 2)
    },
    getPointX(index) {
      if (this.weekly.length <= 1) return '0%'
      const percent = (index / (this.weekly.length - 1)) * 100
      return `${percent}%`
    },
    getPointY(value) {
      if (this.maxGraphValue === 0) return '100%'
      const percent = 100 - (value / this.maxGraphValue) * 100
      return `${percent}%`
    }
  }
}
</script>

<style scoped>
.outlined-card {
  border: 1px solid #dde3f0 !important;
  border-radius: 16px !important;
  box-shadow: 0 2px 12px rgba(25, 50, 120, 0.08) !important;
}
line {
  vector-effect: non-scaling-stroke;
}
</style>
